const { APP_DOMAIN } = Config;

import React from "react";
import { toElementProps } from "../../Element";

export function PaymentLogosStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .payment-logos": {
            width: "260px",
            display: "grid",
            gridAutoFlow: "column",
            alignItems: "center",
            gridGap: "20px",

            [MobileBreakpoint]: {
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
            },
        },
    };
}

export default function PaymentLogos(props) {
    const elProps = toElementProps(props, { className: ["payment-logos"] });

    if (props.variables.__domain !== APP_DOMAIN) {
        return;
    }

    return (
        <div {...elProps}>
            <a href="https://www.paypal.com/" target="_blank">
                <img src="/img/payment-logos/logo-paypal.svg" alt="Logo" width="95px" />
            </a>

            <a href="https://www.liqpay.ua/" target="_blank">
                <img src="/img/payment-logos/logo_liqpay.svg" alt="Logo" width="85px" />
            </a>

            <a href="https://visa.com/" target="_blank">
                <img src="/img/payment-logos/visa.svg" alt="Logo" width="65px" />
            </a>

            <a href="https://mastercard.com/" target="_blank">
                <img src="/img/payment-logos/mc.svg" alt="Logo" width="50px" />
            </a>
        </div>
    );
}
